import { Field } from "formik";
import { isEmpty } from "lodash";
import React from "react";
import {
  FieldButtonGroup,
  FieldInputNumber,
  FieldMultiSelectButtonGroup,
  FieldInputPercentage,
} from "../../../components";
import {
  required,
  toOptionValuesFromMapper,
  OPTIONS_DATA_MAPPER,
} from "../../../utils";
import PaymentFrequencyFields from "./PaymentFrequencyFields";

const DISTRIBUTION_COMMON = [
  {
    label: "Prorata of Choice",
    value: 1,
  },
];

const ONE_TIME_PAYMENT = [
  {
    label: "Allow me to choose",
    value: 1,
  },
];
const PAYMENT_METHOD = [
  {
    label: "One time payment",
    value: 1,
  },
  {
    label: "Periodic Payment",
    value: 2,
  },
];
const DISTRIBUTION_ALLOCATION = [
  {
    label: "Prorata of Choice",
    value: 1,
  },
  {
    label: "Allow me to choose",
    value: 2,
  },
];

const PERIODIC_PAYMENT_METHOD = [
  {
    label: "Prorata of Choice",
    value: 1,
  },
  {
    label: "Hierarchy",
    value: 2,
  },
];
const yesNoOptions = [
  {
    label: "Yes",
    value: true,
  },
  {
    label: "No",
    value: false,
  },
];

const ORDER_OF_PERIODIC_PAYMENT = [
  {
    label: "Source Hierarchy",
    value: 1,
  },
  {
    label: "Investment Hierarchy",
    value: 2,
  },
];

const DistributionAllocationMethodsFields = (props) => {
  const {
    fields,
    values,
    isEdit,
    isSave,
    setFieldValue,
    handleChange,
    isHardShips,
    isRmd,
    isSfs,
    isPermissible,
    isForceOut,
    isQBAD,
  } = props;

  return (
    <div>
      {!isPermissible && !isForceOut && (
        <>
          <p className="plan-sub-heading">Distribution Allocation Methods</p>
          {/* {(isRmd || isSfs) && (
        <>
          <Field
            isRequired
            size="lg"
            name={fields.paymentMethod}
            label={"Payment Method"}
            options={toOptionValuesFromMapper(
              OPTIONS_DATA_MAPPER.PAYMENT_METHOD
            )}
            selectedValue={values[fields.paymentMethod]}
            value={values[fields.paymentMethod]}
            onChange={(value) => {
              setFieldValue(fields.paymentMethod, value);
            }}
            component={FieldMultiSelectButtonGroup}
            disabled={isEdit && !isSave}
          />
        </>
      )} */}
          {/* {(!isRmd &&
        !isSfs && !isHardShips &&
        !isPermissible) && (
          <>
            <Field
              isRequired
              size="smd"
              name={fields.distributionAllocationMethodCommon}
              label={"Common"}
              options={DISTRIBUTION_COMMON}
              selectedValue={values[fields.distributionAllocationMethodCommon]}
              value={values[fields.distributionAllocationMethodCommon]}
              onChange={(value) => {
                setFieldValue(fields.distributionAllocationMethodCommon, value);
              }}
              component={FieldMultiSelectButtonGroup}
              disabled={isEdit && !isSave}
            />
            <Field
              isRequired
              size="smd"
              name={fields.distributionAllocationMethodOntimePayment}
              label={"One time payment"}
              options={ONE_TIME_PAYMENT}
              selectedValue={
                values[fields.distributionAllocationMethodOntimePayment]
              }
              value={values[fields.distributionAllocationMethodOntimePayment]}
              onChange={(value) => {
                setFieldValue(
                  fields.distributionAllocationMethodOntimePayment,
                  value
                );
              }}
              component={FieldMultiSelectButtonGroup}
              disabled={isEdit && !isSave}
            />
          </>
        )} */}
          {/* <Field
        isRequired
        size="lg"
        name={fields.distributionAllocationPaymentMethod}
        label={"Payment Method"}
        options={PAYMENT_METHOD}
        selectedValue={values[fields.distributionAllocationPaymentMethod]}
        value={values[fields.distributionAllocationPaymentMethod]}
        onChange={(value) => {
          setFieldValue(fields.distributionAllocationPaymentMethod, value);
        }}
        component={FieldMultiSelectButtonGroup}
        disabled={isEdit && !isSave}
      /> */}

          <Field
            isRequired
            size="lg"
            name={fields.distributionAllocationMethod}
            label={"Distribution Allocation"}
            options={DISTRIBUTION_ALLOCATION}
            selectedValue={values[fields.distributionAllocationMethod]}
            value={values[fields.distributionAllocationMethod]}
            onChange={(value) => {
              setFieldValue(fields.distributionAllocationMethod, value);
            }}
            component={FieldMultiSelectButtonGroup}
            disabled={isEdit && !isSave}
          />
          {isSfs && (
            <Field
              isRequired
              size="sm"
              name={fields.periodicPaymentApplicable}
              label={"Periodic Payment Applicable"}
              options={yesNoOptions}
              selectedValue={values[fields.periodicPaymentApplicable]}
              value={values[fields.periodicPaymentApplicable]}
              onChange={(value) => {
                setFieldValue(fields.periodicPaymentApplicable, value);
                if (!value) {
                  setFieldValue(fields.dateOfAnnuityPayments, null);
                  setFieldValue(fields.paymentFrequencyApplicable, null);
                  setFieldValue(fields.calculationMethods, null);
                  setFieldValue(fields.periodicPaymentMethod, null);
                }
              }}
              component={FieldButtonGroup}
              disabled={isEdit && !isSave}
            />
          )}

          {values[fields.periodicPaymentApplicable] == true && (
            <>
              <Field
                isRequired
                size="smd"
                name={fields.dateOfAnnuityPayments}
                label={"Date of Annuity Payments"}
                options={toOptionValuesFromMapper(
                  OPTIONS_DATA_MAPPER.ANNUITY_PAYMENTS
                )}
                selectedValue={values[fields.dateOfAnnuityPayments]}
                value={values[fields.dateOfAnnuityPayments]}
                onChange={(value) => {
                  setFieldValue(fields.dateOfAnnuityPayments, value);
                  if (value?.length === 1 && value?.[0] === 2) {
                    setFieldValue(fields.paymentFrequencyApplicable, null);
                  }
                }}
                component={FieldMultiSelectButtonGroup}
                disabled={isEdit && !isSave}
              />

              <PaymentFrequencyFields {...props} />

              <Field
                isRequired
                size="lg"
                name={fields.periodicPaymentMethod}
                label={"Periodic Payment Method"}
                options={PERIODIC_PAYMENT_METHOD}
                selectedValue={values[fields.periodicPaymentMethod]}
                value={values[fields.periodicPaymentMethod]}
                onChange={(value) => {
                  setFieldValue(fields.periodicPaymentMethod, value);
                }}
                component={FieldMultiSelectButtonGroup}
                disabled={isEdit && !isSave}
              />
              {values[fields.calculationMethods]?.includes(8) && (
                <Field
                  isRequired
                  size="xs"
                  name={fields.interestRate}
                  label={"Interest Rate"}
                  type="number"
                  autoComplete="off"
                  value={values[fields.interestRate]}
                  selectedValue={values[fields.interestRate]}
                  onChange={handleChange}
                  disabled={isEdit && !isSave}
                  component={FieldInputPercentage}
                  hasSuggestion
                  shouldDisplaySuggestion
                />
              )}
            </>
          )}
          {/* {values[fields.periodicPaymentApplicable]==true && (
      {(isSfs) && <PaymentFrequencyFields {...props} />}
       */}
          {/* <Field
        isRequired
        size="lg"
        name={fields.periodicPaymentMethod}
        label={"Periodic Payment Method"}
        options={PERIODIC_PAYMENT_METHOD}
        selectedValue={values[fields.periodicPaymentMethod]}
        value={values[fields.periodicPaymentMethod]}
        onChange={(value) => {
          setFieldValue(fields.periodicPaymentMethod, value);
        }}
        component={FieldMultiSelectButtonGroup}
        disabled={isEdit && !isSave}
      /> */}

          {/* <Field
          isRequired
          size="xs"
          name={fields.interestRate}
          label={"Interest Rate"}
          type="number"
          autoComplete="off"
          value={values[fields.interestRate]}
          selectedValue={values[fields.interestRate]}
          onChange={handleChange}
          disabled={isEdit && !isSave}
          component={FieldInputPercentage}
          hasSuggestion
          shouldDisplaySuggestion
        /> */}

          {/* {!isRmd && !isSfs && !isPermissible && !isHardShips && (
        <Field
          isRequired
          size="lg"
          name={fields.orderOfPeriodicPayment}
          label={"Order of Periodic Payment"}
          options={ORDER_OF_PERIODIC_PAYMENT}
          selectedValue={values[fields.orderOfPeriodicPayment]}
          value={values[fields.orderOfPeriodicPayment]}
          onChange={(value) => {
            setFieldValue(fields.orderOfPeriodicPayment, value);
          }}
          component={FieldMultiSelectButtonGroup}
          disabled={isEdit && !isSave}
        />
      )} */}
          {isSfs && (
            <Field
              size="xs"
              isRequired
              name={fields.maximumNumberOfDirectRolloverPayees}
              label={"Maximum Number of direct rollover payees"}
              type="number"
              autoComplete="off"
              value={values[fields.maximumNumberOfDirectRolloverPayees]}
              onChange={handleChange}
              disabled={isEdit && !isSave}
              component={FieldInputNumber}
              min={0}
              max={99}
            />
          )}

          <br />
        </>
      )}
      {/* )} */}
    </div>
  );
};

export default DistributionAllocationMethodsFields;
